import $ from 'jquery';

const counterThousandFormat = () => {
	const el = {
		main: '.mi-counter-thousand',
		counter: '.mi-counter-thousand .elementor-counter-number',
	};

	if ($(el.main).length === 0) return;

	const init = () => {
		initCounterFormat();
	};

	const initCounterFormat = () => {
		const $counter = $(el.counter);

		if ($counter.length === 0) return;

		const counter = $counter.get(0);
		const num = parseInt(counter.getAttribute('data-to-value'), 10);

		if (num >= 1000) {
			counter.setAttribute('data-to-value', num / 1000);
			$counter.addClass('has-k');
		}
	};

	init();
};

try {
	counterThousandFormat();
} catch (error) {
	console.error('counterThousandFormat', error);
}
